/*
 * Sub-menus of the website header (pages of „Seiten“ with sub-pages; siteNav.header → NavItem.children). Design-
 * independent disclosure pattern – each template renders and styles it:
 *   <li> <a href>Verein</a> <button data-subnav-toggle aria-expanded="false" aria-controls="sub-1">…</button>
 *        <ul id="sub-1" hidden> … </ul> </li>
 * A toggle opens/closes its list; opening one closes the others; Esc closes and returns the focus to the toggle; a
 * click outside closes. In the phone menu the same lists open inline (the template's CSS decides).
 */
(function () {
  'use strict';
  var toggles = [];
  var MORE_PANEL = '[data-nav-more-panel], .b2-more'; // the „Mehr“ panel (data hook first, bootstrap-v2 class as fallback)
  // RC70 O1: „Mehr“ as a flyout (navMore.xhtml param style=Flyout → data-nav-more-style="flyout" on the „Mehr“ li): one list, every moved parent
  // keeps its toggle and opens its sub-list beside the panel. Without the attribute the panel is the Mega-Menü grid (sub-lists shown open).
  var FLYOUT = '[data-nav-more-style="flyout"]';
  function inFlyout(el) { return !!(el.closest && el.closest(FLYOUT)); }

  function set(btn, open) {
    var list = document.getElementById(btn.getAttribute('aria-controls'));
    if (!list) { return; }
    // Mega-Menü: a sub-menu moved into the „Mehr“ panel (data-nav-overflow) is shown open there – its toggle is hidden
    var panel = btn.closest ? btn.closest(MORE_PANEL) : null;
    if (panel && !inFlyout(panel)) { return; }
    btn.setAttribute('aria-expanded', String(open));
    list.hidden = !open;
    if (!open) { // a flyout open inside a closing panel closes with it (the panel opens clean next time)
      for (var i = 0; i < toggles.length; i++) {
        if (toggles[i] !== btn && toggles[i].getAttribute('aria-expanded') === 'true' && list.contains(toggles[i])) { set(toggles[i], false); }
      }
    }
    var li = btn.closest ? btn.closest('li') : null;
    if (li) { li.classList.toggle('is-open', open); }
    // flyout: no room left of the panel (very short menubar) → the flyout opens below its row (_nav-more.scss)
    if (panel && open) { panel.toggleAttribute('data-flyout-inline', panel.getBoundingClientRect().left < 15 * remPx()); }
  }

  function remPx() { return parseFloat(getComputedStyle(document.documentElement).fontSize) || 16; }

  // closes every open toggle except `except` and its ancestors (a flyout opens inside the open „Mehr“ panel, which stays open)
  function closeAll(except) {
    for (var i = 0; i < toggles.length; i++) {
      var t = toggles[i];
      if (t === except || t.getAttribute('aria-expanded') !== 'true') { continue; }
      var own = document.getElementById(t.getAttribute('aria-controls'));
      if (except && own && own.contains(except)) { continue; }
      set(t, false);
    }
  }

  function init() {
    var found = document.querySelectorAll('[data-subnav-toggle]');
    for (var i = 0; i < found.length; i++) {
      var btn = found[i];
      if (btn.getAttribute('data-subnav-ready')) { continue; }
      btn.setAttribute('data-subnav-ready', '1');
      toggles.push(btn);
      set(btn, false);
      btn.addEventListener('click', function (e) {
        var b = e.currentTarget;
        var open = /** @type {Element} */ (b).getAttribute('aria-expanded') !== 'true';
        closeAll(b);
        set(b, open);
      });
    }
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') { return; }
    // the innermost open list that holds the focus closes first (a flyout before its „Mehr“ panel), then the next Esc closes the outer one
    var hit = null, hitList = null;
    for (var i = 0; i < toggles.length; i++) {
      var b = toggles[i];
      var list = document.getElementById(b.getAttribute('aria-controls'));
      if (b.getAttribute('aria-expanded') === 'true' && list && (list.contains(document.activeElement) || b === document.activeElement)
          && (!hitList || hitList.contains(list))) {
        hit = b; hitList = list;
      }
    }
    if (hit) {
      set(hit, false);
      hit.focus();
      e.stopPropagation(); // the phone menu stays open; a second Esc closes it
    }
  }, true);

  document.addEventListener('click', function (e) {
    for (var i = 0; i < toggles.length; i++) {
      var li = toggles[i].closest ? toggles[i].closest('li') : null;
      if (li && !li.contains(e.target)) { set(toggles[i], false); }
    }
  });

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }

  /*
   * Opt-in (RC11 bsv2-design, RC42 S6 for atelier, jrk, kinetik, standard-v2/baukasten): <nav data-nav-overflow> with the hooks
   * [data-nav-list] (the top-level ul), [data-nav-more] (its last li), [data-nav-more-btn] (button, aria-controls = panel),
   * [data-nav-more-panel] (the panel), [data-nav-more-list] (ul in the panel), [data-nav-count], [data-nav-keep] (li never moved,
   * e.g. home), data-nav-wide (media query of the one-row menubar, default (min-width: 64rem)) and data-nav-max (optional cap of the menubar entries). Every hook falls back to the
   * bootstrap-v2 class (FALLBACK), whose markup stays as it was. At the wide query the top-level entries that do not fit into
   * one row move – as nodes, never as HTML – to the front of the „Mehr“ panel (panel order = menu order); below, everything
   * stays in the list (phone menu). Current page: aria-current on the matching link, .is-current on its sub-menu button / „Mehr“.
   */
  var FALLBACK = { list: '.b2-nav__list', more: '.b2-nav__more', cols: '.b2-more__cols', btn: '.b2-nav__morebtn', count: '.b2-nav__count', keep: '.b2-nav__item--home' };
  function hook(root, name, fallback) { return root.querySelector('[data-nav-' + name + ']') || root.querySelector(fallback); }

  function overflowNav(nav) {
    var list = hook(nav, 'list', FALLBACK.list);
    var more = list && (list.querySelector(':scope > [data-nav-more]') || list.querySelector(':scope > ' + FALLBACK.more));
    var cols = more && hook(more, 'more-list', FALLBACK.cols);
    var btn = more && hook(more, 'more-btn', FALLBACK.btn);
    if (!cols || !btn) { return; }
    var count = hook(more, 'count', FALLBACK.count);
    var label = nav.getAttribute('data-more-label') || 'Mehr, {n}';
    var wideQuery = nav.getAttribute('data-nav-wide') || '(min-width: 64rem)';
    // data-nav-max (optional, jrk designer feedback 2026-10-14): at most n top-level entries stay in the menubar, the rest go to „Mehr“
    var max = parseInt(nav.getAttribute('data-nav-max'), 10);
    var wide = window.matchMedia ? window.matchMedia(wideQuery) : { matches: true };
    var fly = more.getAttribute('data-nav-more-style') === 'flyout';
    var items = [];
    var kids = list.children;
    for (var i = 0; i < kids.length; i++) {
      if (kids[i] !== more) { kids[i].setAttribute('data-nav-i', String(i)); items.push(kids[i]); }
    }

    function subs(li, inPanel) {
      var t = li.querySelectorAll('[data-subnav-toggle]');
      li.toggleAttribute('data-nav-flyout', !!inPanel && fly && t.length > 0);
      for (var k = 0; k < t.length; k++) {
        var l = document.getElementById(t[k].getAttribute('aria-controls'));
        if (fly) {
          // flyout: every toggle (also the label of a not clickable main page) opens its list beside the panel; closed when it moves
          t[k].setAttribute('aria-expanded', 'false');
          li.classList.remove('is-open');
          if (l) { l.hidden = true; }
          continue;
        }
        // Mega-Menü: an inert group heading (not clickable main page) is no tab stop while it sits in the panel
        t[k].disabled = !!inPanel && /__subtoggle--label/.test(t[k].className);
        if (inPanel) {
          t[k].setAttribute('aria-expanded', 'false');
          if (l) { l.hidden = false; }
        } else if (l) {
          l.hidden = t[k].getAttribute('aria-expanded') !== 'true';
        }
      }
    }
    function reset() {
      var moved = cols.children;
      while (moved.length) {
        var li = moved[0];
        cols.removeChild(li);
        subs(li, false);
        var n = Number(li.getAttribute('data-nav-i'));
        var before = null;
        for (var j = 0; j < list.children.length; j++) {
          var c = list.children[j];
          if (c === more || Number(c.getAttribute('data-nav-i')) > n) { before = c; break; }
        }
        list.insertBefore(li, before);
      }
    }
    function overflows() {
      if (max > 0 && list.children.length - 1 > max) { return true; }
      if (list.scrollWidth > list.clientWidth + 1) { return true; }
      var last = more.previousElementSibling;
      return !!last && !more.hidden && last.getBoundingClientRect().right > more.getBoundingClientRect().left + 1;
    }
    function layout() {
      btn.setAttribute('aria-expanded', 'false');
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (panel) { panel.hidden = true; }
      reset();
      more.hidden = true;
      if (!wide.matches) { mark(); return; }
      more.hidden = false;
      var n = 0;
      while (overflows()) {
        var li = more.previousElementSibling;
        if (!li || li.hasAttribute('data-nav-keep') || li.matches(FALLBACK.keep)) { break; }
        list.removeChild(li);
        cols.insertBefore(li, cols.firstChild);
        subs(li, true);
        n++;
      }
      if (!n) {
        more.hidden = true;
      } else {
        if (count) { count.textContent = String(n); }
        cols.style.setProperty('--b2-cols', fly ? '1' : String(Math.min(4, Math.ceil(n / 4))));
        (cols.closest(MORE_PANEL) || cols).style.setProperty('--nav-more-cols', fly ? '1' : String(Math.min(3, Math.ceil(n / 5))));
        btn.setAttribute('aria-label', label.replace('{n}', String(n)));
      }
      mark();
    }
    function norm(p) { return (p || '/').replace(/\/index\.x?html$/, '/').replace(/\/?$/, '/'); }
    var markParent = nav.hasAttribute('data-nav-mark-parent');
    function mark() {
      var here = norm(location.pathname);
      var cur = nav.querySelectorAll('.is-current');
      for (var c = 0; c < cur.length; c++) { cur[c].classList.remove('is-current'); }
      var links = nav.querySelectorAll('a[href]');
      if (markParent) {
        for (var q = 0; q < links.length; q++) { if (links[q].getAttribute('aria-current') === 'true') { links[q].removeAttribute('aria-current'); } }
      }
      for (var k = 0; k < links.length; k++) {
        var a = links[k];
        var same = a.host === location.host && norm(a.pathname) === here && !a.hash;
        if (same) { a.setAttribute('aria-current', 'page'); } else if (a.getAttribute('aria-current') === 'page') { a.removeAttribute('aria-current'); }
        if (!same) { continue; }
        var sub = a.closest('ul[id]');
        if (markParent && sub) { // RC48 A3 (opt-in data-nav-mark-parent): the parent entry of the current sub page is marked too (aria-current="true" = ancestor)
          var pli = sub.parentElement, pa = pli && pli.querySelector(':scope > a[href]');
          if (pa && pa !== a) { pa.setAttribute('aria-current', 'true'); }
        }
        var toggle = sub && nav.querySelector('[aria-controls="' + (window.CSS && CSS.escape ? CSS.escape(sub.id) : sub.id.replace(/["\\]/g, '\\$&')) + '"]'); // the owner's raw menu HTML may carry any id
        var inMore = !!a.closest(MORE_PANEL);
        if (toggle && !inMore) { toggle.classList.add('is-current'); }
        if (inMore) { btn.classList.add('is-current'); }
      }
    }
    var queued = false;
    function schedule() {
      if (queued) { return; }
      queued = true;
      (window.requestAnimationFrame || setTimeout)(function () { queued = false; layout(); });
    }
    layout();
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(schedule); }
    if (window.ResizeObserver) {
      var lastW = 0;
      new ResizeObserver(function (e) {
        var w = Math.round(e[0].contentRect.width);
        if (w !== lastW) { lastW = w; schedule(); }
      }).observe(nav);
    } else {
      window.addEventListener('resize', schedule);
    }
    if (/** @type {any} */ (wide).addEventListener) { /** @type {any} */ (wide).addEventListener('change', schedule); } else if (/** @type {any} */ (wide).addListener) { /** @type {any} */ (wide).addListener(schedule); }
    window.addEventListener('load', schedule);
  }

  function initOverflow() {
    var navs = document.querySelectorAll('[data-nav-overflow]');
    for (var i = 0; i < navs.length; i++) {
      if (!navs[i].getAttribute('data-overflow-ready')) { navs[i].setAttribute('data-overflow-ready', '1'); overflowNav(navs[i]); }
    }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initOverflow); } else { initOverflow(); }
})();
